import { obeliskClient } from './obelisk';
import configs from '../config/app';

class botClient extends obeliskClient {
  constructor() {
    super();
    this.version = configs.botVersion;
    this.baseUrl = configs.botApi;
    this.init();
    this.headers = {};
    const token = configs.botKey;
    this.setHeader('x-api-key', `${token || ''}`);
    this.setHeader('Content-Type', 'application/json');
    this.setHeader('Accept', 'application/json');
  }
  /**
   * @param {string} keyName
   * @returns {string}
   */
  getCallByType(keyName) {
    return `/functions/v${this.version}/${keyName}`;
  }

  url(service, params = {}) {
    let queryParams = { ...params };
    const self = new botClient();
    const url = `${configs.botApi}${self.getCallByType(service)}`;
    if (!params?.clientId) {
      queryParams.clientId = configs.clientId;
    }
    const queryString = new URLSearchParams(queryParams).toString();
    return queryString ? `${url}?${queryString}` : url;
  }
}

const http = () => new botClient();
export default http;
